<template>
    <div class="nocardpage">
        <div class="content" >
            <span class="block imgbox">
              <img src="../../assets/images/addcard.png" alt class="nocardpic">
            </span>
            <span class="block">请先添加就诊卡</span>
          </div>
    </div>
</template>
<script>
export default {
    name:'nocard'
}

</script>
<style>
.nocardpage{
    width: 100%;
    height: 100%;
}
.nocardpage .content {
  height: 2.4rem;
  text-align: center;
  background-color: white;
  color: #3d97d1;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;


}

.nocardpage .imgbox{
 position: relative;
 height: 1.5rem;
 display: block;
}
.nocardpage .nocardpic {
     top: 50%;
    width: 0.81rem;
    height: 0.81rem;
    margin-bottom: 0.28rem;
    position: absolute;
    left: 50%;
    margin-left: -0.4rem;
    margin-top: -0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/waitinginfo/nocard.vue